import React from 'react';
import { Hamburger } from './Hamburger';
import { NavbarContext } from '../../../context';
import './TopBar.scss';

const TopBarLeft = ({ children }) => {
  return <div className='top-bar-content'>{children}</div>;
};

const TopBarTitle = ({ children }) => {
  return <p className='top-bar-title'>{children}</p>;
};

const TopBarRight = ({ children }) => {
  return <div className='top-bar-right'>{children}</div>;
};

const TopBarUnwrapped = ({ onToggle, children }) => {
  const onClickHamburger = React.useCallback(
    (e) => {
      e.preventDefault();
      onToggle();
    },
    [onToggle]
  );

  return (
    <div className='top-bar'>
      <Hamburger onClick={onClickHamburger} />
      {children}
    </div>
  );
};

export class TopBar extends React.Component<{}, {}> {
  static Title = TopBarTitle;
  static Left = TopBarLeft;
  static Right = TopBarRight;

  render() {
    return (
      <NavbarContext.Consumer>
        {({ toggle }) => <TopBarUnwrapped onToggle={toggle}>{this.props.children}</TopBarUnwrapped>}
      </NavbarContext.Consumer>
    );
  }
}
